// extracted by mini-css-extract-plugin
module.exports = {"receipt-total-box":"hDdBYX50TYDEB4HCixExw","receipt-total":"_1pJP2F-KQhFm3YAeVJTxnY","overflow-word":"Tljj17VriKN35TD8WkZSZ","payment-note":"_2PQioLoU0F_4jbOyGkQ5S1"};